import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { PhoneField } from "../../../components/PhoneField";
import { friendlyError } from "./_shared";

// Pre-MAIN contact-only correction: changes the sender contact mobile; Quote/price/acceptance unchanged.
export function SenderContactEdit({ shipmentId, current, onSaved }) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(current || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const valid = /^[0-9]{10}$/.test(value) && value !== current;

  const save = async () => {
    setBusy(true);
    setError("");
    try {
      await api.patch(`/booking/${shipmentId}/sender-contact`, { sender_contact_mobile: value });
      toast.success("Contact mobile updated");
      setOpen(false);
      onSaved();
    } catch (e) {
      const det = e?.response?.data?.detail;
      setError(e?.response?.status === 422 ? "Enter exactly 10 digits."
        : friendlyError(e, "We couldn't update the contact mobile. Please try again."));
      if (det?.code === "DRAFT_LOCKED") onSaved();
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button type="button" className="ml-2 text-xs underline" onClick={() => { setValue(current || ""); setError(""); setOpen(true); }}
              data-testid="sender-contact-edit-button">Edit</button>
    );
  }
  return (
    <div className="mt-2 space-y-2" data-testid="sender-contact-edit-form">
      <PhoneField value={value} onChange={setValue} testid="sender-contact-edit-input" />
      <p className="text-[11px] text-[hsl(var(--muted))]">Changes the contact number only. Your quote, price and acceptance stay the same.</p>
      {value && !/^[0-9]{10}$/.test(value) && <p className="text-xs text-red-600" data-testid="sender-contact-edit-invalid">Enter exactly 10 digits.</p>}
      {error && <p className="text-xs text-red-600" data-testid="sender-contact-edit-error">{error}</p>}
      <div className="flex gap-2">
        <button type="button" className="btn-primary text-xs" disabled={!valid || busy} onClick={save} data-testid="sender-contact-edit-save">
          {busy ? "Saving…" : "Save"}
        </button>
        <button type="button" className="btn-ghost text-xs" disabled={busy} onClick={() => setOpen(false)} data-testid="sender-contact-edit-cancel">Cancel</button>
      </div>
    </div>
  );
}
